module.exports = __webpack_public_path__ + "img/redis.107069d8.png";